import { useApolloClient } from "@apollo/client";
import { useCallback, useMemo } from "react";

/**
 * Provides helpers for clearing reservation-related Apollo cache data.
 */
export default function useReservationsCache(userId?: string) {
  const apolloClient = useApolloClient();
  const userCacheId = useMemo(
    () =>
      userId
        ? apolloClient.cache.identify({
            __typename: "VenuePortalUser",
            id: userId,
          })
        : undefined,
    [apolloClient.cache, userId],
  );

  /**
   * Clears cached reservation range data for the current user.
   */
  const clearReservationsCache = useCallback(() => {
    if (!userCacheId) return;
    apolloClient.cache.modify({
      id: userCacheId,
      fields: {
        reservationsRange(_, { DELETE }) {
          return DELETE;
        },
      },
    });
  }, [apolloClient.cache, userCacheId]);

  return { clearReservationsCache };
}
